import CircularProgress from '@mui/material/CircularProgress';
import { Fragment } from 'react';
import css from './styles/LoadingSpinner.module.scss';

interface Props {
  customStyles?: any;
  size?: number;
}

function LoadingSpinner(props: Props) {
  return (
    <Fragment>
      <div className={css.loadingContainer} style={props.customStyles} />
      <CircularProgress className={css.loadingSpinner} variant={'indeterminate'} size={props.size ? props.size : 60} />
    </Fragment>
  );
}

export default LoadingSpinner;
